import { BoxProps, Card, HStack, Stack, Text, TextProps } from "@chakra-ui/react";
import CopyButton from "components/Button/Copy";
import { useCopy } from "hooks";
import { showFirstLastChar } from "utils";

export interface ExchangeInfoProps extends Omit<BoxProps, "title"> {
  title?: string;
}
export interface ExchangeInfoDetailProps extends Omit<BoxProps, "title"> {
  title: string;
  description: string;
  secondDescription?: string;
  thirdDescription?: string;
  descriptionColor?: string;
  canCopy?: boolean;
  copyValue?: string;
  _title?: TextProps;
  _description?: TextProps;
  hideInfo?: boolean;
}
export function ExchangeInfo(props: ExchangeInfoProps) {
  const { title, children, ...xprops } = props;
  return (
    <Card w="100%" p="0" borderRadius="10px" bg="#F8F9F9" shadow="none" {...xprops}>
      {!!title && (
        <Text
          py={{ base: "12px", "1sm": "20px" }}
          fontSize="16px"
          fontWeight="600"
          color="primary.default"
          border="1px solid transparent"
          borderBottomColor="#F0F1F3"
          px="12px"
        >
          {title}
        </Text>
      )}

      <Stack px="12px" py={{ base: "12px", "1sm": "20px" }} gridGap="10px" sx={{ "> *": { mt: "0 !important" } }}>
        {children}
      </Stack>
    </Card>
  );
}

export function ExchangeInfoDetail(props: ExchangeInfoDetailProps) {
  const {
    title,
    description,
    secondDescription,
    thirdDescription,
    canCopy = false,
    _title,
    _description,
    descriptionColor,
    hideInfo,
    ...xprops
  } = props;

  const { onCopy } = useCopy(description ?? "");
  return (
    <HStack justifyContent="space-between" fontSize="14px" fontWeight="500" {...xprops}>
      <Text {..._title}>{title}</Text>
      <HStack justifyContent={{ base: "right", md: "initial" }} flexWrap={{ base: "wrap", md: "initial" }} gap={{ base: "0" }}>
        <Text color={descriptionColor ? descriptionColor : ""} {..._description}>
          {secondDescription} {hideInfo ? showFirstLastChar(description, 8) : description} {thirdDescription}
        </Text>
        {!!canCopy && <CopyButton onClick={onCopy} />}
      </HStack>
    </HStack>
  );
}
